import { customComponents } from './customComponents';

export const customTheme = customComponents;
